import React from "react";
import { Link } from "../lib/Link";

export const customer_voice = (type, isBlock) => {
  return (
    <div className="customer_voice">
      <div className="message">
        <div className="title">お客様インタビュー</div>
        {isBlock ? ("") : (<div>トランクルーム選びの参考に</div>)}
      </div>
      <div className="collection">
        <Link to="/voice2/voice_case1/" className="item">
          <div className="image" style={{
              backgroundImage:
              "url(resource/img/static/voice2/voice_case1/img_1.jpg)",
              }}
          />
          <div className="person">自営業　２８才 男性</div>
          <div className="voice_info">仕事道具の収納場所に借りました。</div>
        </Link>
        <Link to="/voice2/voice_case2/" className="item">
          <div className="image" style={{
              backgroundImage:
              "url(resource/img/static/voice2/voice_case2/img_1.jpg)",
              }}
          />
          <div className="person">建築会社勤務　３０代 女性</div>
          <div className="voice_info">引っ越すよりお得！？</div>
        </Link>
        <Link to="/voice2/voice_case3/" className="item">
          <div className="image" style={{
              backgroundImage:
              "url(resource/img/static/voice2/voice_case3/img_1.jpg)",
              }}
          />
          <div className="person">広告代理店勤務　３４才 男性</div>
          <div className="voice_info">職場近くのウォークインクローゼット</div>
        </Link>
        <Link to="/voice2/voice_case4/" className="item">
          <div className="image" style={{
              backgroundImage:
              "url(resource/img/static/voice2/voice_case4/img_1.jpg)",
              }}
          />
          <div className="person">メーカー勤務　２９才 女性</div>
          <div className="voice_info">新婚生活の収納場所として</div>
        </Link>
      </div>
      {isBlock ? ("") : (
        <Link to="/voice2/" className="btn center black">
          お客様の声
        </Link>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/customer_voice.jsx